import { getEmployees, getAdminEmployees, getEmployeeRoles, editEmployeeRole, addEmployeeRole, syncEmployeeData, getSupervisors, updateEmployeeAssignedRole, updateEmployeeCanAddDriveTime, updateEmployeeCompanyPhone, updateEmployeeCanCreateWorkOrders, updateEmployeeActive } from "../api/employee";
import { EmployeeInfo, RoleWriteInput } from "../interfaces/EmployeeInfoInterface";

// Function to get employees
const grabEmployees = async () => {
    try {
        const response = await getEmployees();
        return response;
    } catch (error) {
        console.error("Error in grabEmployees:", error);
        throw error;
    }
};

// Function to get admin employees
const grabAdminEmployees = async () => {
    try {
        const response = await getAdminEmployees();
        return response;
    } catch (error) {
        console.error("Error in grabAdminEmployees:", error);
        throw error;
    }
};

// Function to get employee roles
const grabEmployeeRoles = async () => {
    try {
        const response = await getEmployeeRoles();
        return response;
    } catch (error) {
        console.error("Error in grabEmployeeRoles:", error);
        throw error;
    }
};

// Function to get supervisors
const grabSupervisors = async () => {
    try {
        const response = await getSupervisors();
        return response;
    } catch (error) {
        console.error("Error in grabSupervisors:", error);
        throw error;
    }
};

// Function to create employee role
const createEmployeeRole = async (newRole: RoleWriteInput) => {
    try {
        const response = await addEmployeeRole(newRole);
        return response;
    } catch (error) {
        console.error("Error in createEmployeeRole:", error);
        throw error;
    }
};

// Function to change employee role
const changeEmployeeRole = async (roleID: number, updatedRole: RoleWriteInput) => {
    try {
        const response = await editEmployeeRole(roleID, updatedRole);
        return response;
    } catch (error) {
        console.error("Error in changeEmployeeRole:", error);
        throw error;
    }
};

// Function to update employee data
const updateEmployeeData = async (altID: String, altLocationID: String) => {
    try {
        const response = await syncEmployeeData(altID, altLocationID);
        return response;
    } catch (error) {
        console.error("Error in updateEmployeeData:", error);
        throw error;
    }
};

const changeEmployeeAssignedRole = async (employeeID: number, roleID: number) => {
    try {
        const response = await updateEmployeeAssignedRole(employeeID, roleID);
        return response;
    } catch (error) {
        console.error("Error in changeEmployeeAssignedRole:", error);
        throw error;
    }
};

const changeEmployeeCanAddDriveTime = async (employeeID: number, canAddDriveTime: boolean) => {
    try {
        const response = await updateEmployeeCanAddDriveTime(employeeID, canAddDriveTime);
        return response;
    } catch (error) {
        console.error("Error in changeEmployeeCanAddDriveTime:", error);
        throw error;
    }
};

const changeEmployeeCompanyPhone = async (employeeID: number, hasCompanyPhone: boolean, startDate?: string) => {
    try {
        const response = await updateEmployeeCompanyPhone(employeeID, hasCompanyPhone, startDate);
        return response;
    } catch (error) {
        console.error("Error in changeEmployeeCompanyPhone:", error);
        throw error;
    }
};

const changeEmployeeActive = async (employeeID: number, active: boolean) => {
    try {
        const response = await updateEmployeeActive(employeeID, active);
        return response;
    } catch (error) {
        console.error("Error in changeEmployeeActive:", error);
        throw error;
    }
};

const changeEmployeeCanCreateWorkOrders = async (employeeID: number, canCreateWorkOrders: boolean) => {
    try {
        const response = await updateEmployeeCanCreateWorkOrders(employeeID, canCreateWorkOrders);
        return response;
    } catch (error) {
        console.error("Error in changeEmployeeCanCreateWorkOrders:", error);
        throw error;
    }
};

export { grabEmployees, grabAdminEmployees, grabEmployeeRoles, grabSupervisors, createEmployeeRole, changeEmployeeRole, updateEmployeeData, changeEmployeeAssignedRole, changeEmployeeCanAddDriveTime, changeEmployeeCompanyPhone, changeEmployeeCanCreateWorkOrders, changeEmployeeActive };